<template>
  <pro-list-frame
    ref="plTable"
    :title="(titleProp ? $t(titleProp) : $t($route.name))"
    icon="mdi-checkbook"
    :total="totalItems"
    :rows="items.length"
    :search.sync="search"
    :columns="toggleableHeaders"
    :hidden="hiddenColumns"
    :selected-count="selected.length"
    :loading="loading"
    :cell-sel="cellSel"
    :fixed="!mobileShow"
    :create-label="(!mobileShow) ? $t(type) : ''"
    @refresh="getItems"
    @filter="filter = true"
    @print="printStudio = true"
    @create="goTo(type)"
    @toggle-column="toggleColumn"
    @show-all-columns="hiddenColumns = []"
    @cell-down="onCellDown"
    @cell-over="onCellOver"
    @clear-cells="clearCellSel"
    @clear-selection="selected = []"
  >
    <template #tools>
      <export-excel
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      <v-menu offset-y left>
        <template v-slot:activator="{ attrs, on }">
          <button type="button" class="pl-btn pl-btn--icon" v-bind="attrs" v-on="on">
            <v-icon size="16">mdi-dots-vertical</v-icon>
          </button>
        </template>
        <v-list dense>
          <v-list-item
            link
            v-show="type === 'removedChecks'"
            :disabled="!selected || (selected && selected.length === 0) ? true : false"
            @click="refreshRemovedItem"
          >
            <v-list-item-icon>
              <v-icon>mdi-delete-restore</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refreshRemovedChecks')" />
          </v-list-item>
          <v-list-item
            link
            v-if="lockPermission && selected.length > 0"
            :disabled="!selected || (selected && selected.length === 0) ? true : false"
            @click="lockGroup('lock')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('lock')" />
          </v-list-item>
          <v-list-item
            v-if="lockPermission && selected.length > 0"
            link
            @click="unlockGroup('unlock')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock-open-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('unlock')" />
          </v-list-item>
          <v-list-item v-show="type === 'recieveCheck'" link @click="openUploadDialog">
            <v-list-item-icon>
              <v-icon>mdi-database-import-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('importData')" />
          </v-list-item>
          <log
            v-if="
              $store.state.permissions && $store.state.permissions.includes('logList')
            "
            ref="logRef"
            :type-prop="type"
            :listProp="true"
            mode-prop="button"
          />
          
          
          
          
        </v-list>
      </v-menu>
    </template>
    <template #kpis>
      <div class="pl-kpi pl-kpi--blue">
        <span class="pl-kpi__icon"><v-icon size="17">mdi-chart-bar</v-icon></span>
        <div class="pl-kpi__body">
          <span class="pl-kpi__label">{{ $t("totalSum") }}</span>
          <span class="pl-kpi__value pl-num">{{ faNum($numberFormat(summary ? summary.amount : 0)) }}</span>
        </div>
      </div>
    </template>
    <template #bulk>
      <button
        v-if="receiptKind"
        type="button"
        class="pl-bulk__btn"
        @click="receiptPrint()"
      >
        <v-icon size="17">mdi-printer-settings</v-icon>
        {{ $t("receiptGroupPrint") }}
      </button>
      <button
        v-if="type !== 'removedChecks' && !mobileShow"
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
    </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-model="selected"
        v-column-resize="checksListColumnPlugins"
        v-column-drag="checksListColumnPlugins"
        v-column-pin="checksListColumnPlugins"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        :headers="tableHeaders"
        :items="items"
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :loading="false"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :hide-default-header="isMobile || mobileShow"
        :page.sync="page"
        :footer-props="plFooterProps"
      >
        <template v-if="isMobile || mobileShow" v-slot:item="{ item, index }">
          <tr :class="{ 'mobile-show': mobileShow }">
            <td class="px-0">
              <v-list-item
                class="data-table-list-items px-0"
                :class="{
                  'mobile-td-list-border-red': item.type == 'own' ? true : false,
                  'mobile-td-list-border-green': item.type == 'customer' ? true : false,
                }"
                dense
              >
                <v-list-item-icon class="ps-2 me-1">
                  <div class="d-flex">
                    <p class="mt-3">
                      {{ +index + +1 }}
                    </p>
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn color="primary" v-bind="attrs" icon v-on="on">
                          <v-icon medium> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          v-if="
                            (item.status && item.status.status == 'issued') ||
                            (item.status && item.status.status == 'fund')
                          "
                          link
                          :disabled="item.lock ? true : false"
                          @click="edit(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-clipboard-edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item
                          v-show="item.kind !== 'guarantee'"
                          link
                          @click="openCheckStatusDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-qrcode-edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('change') + ' ' + $t('status')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="editLink(item)"
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                        <v-list-item v-if="item.doc_head_id" link @click="viewDocument(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-file-eye-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('viewAccountingDoc')" />
                        </v-list-item>
                        <v-list-item v-if="receiptKind" link @click="receiptPrint(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-receipt-text-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('treasuryReceiptPrint')" />
                        </v-list-item>
                        <v-list-item v-if="type === 'payCheck'" link @click="chequePrint(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-checkbook</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('chequeLeafPrint')" />
                        </v-list-item>
                        <v-list-item link @click="documentPrint(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-printer-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            v-text="$t('print') + ' ' + $t('document')"
                          />
                        </v-list-item>
                        <log
                          :title-prop="$t('history')"
                          icon-prop="mdi-history"
                          :listProp="true"
                          :type-prop="typeForm"
                          :refIdProp="item.id"
                          mode-prop="button"
                        />
                        <v-list-item
                          v-if="
                            ((item.status && item.status.status == 'issued') ||
                              (item.status && item.status.status == 'fund')) &&
                            removePermission(type)
                          "
                          link
                          :disabled="item.lock ? true : false"
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content class="pb-0">
                  <v-list-item-title class="text-wrap">
                    {{ item.account ? item.account.name : "" }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("bank") }} : {{ item.bank ? item.bank.name : "" }} |
                    {{ $t("number") }} {{ $t("check") }}: {{ item.number }} |
                    {{ $t("id") }} : {{ item.id }} | {{ $t("date") }} : {{ item.date }} |
                    {{ $t("due") }} : {{ item.due_date }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <v-chip
                      v-if="item.status && item.status.status"
                      :color="item.status.color"
                      label
                      small
                      style="cursor: pointer"
                      class="px-1"
                      @click="openCheckStatusDialog(item)"
                    >
                      <span class="px-2 white--text">
                        {{ $t(item.status.status) }}
                      </span>
                    </v-chip>
                    <v-chip
                      v-if="item.payed_account_id && item.type == 'customer'"
                      color="primary"
                      label
                      small
                      style="cursor: pointer"
                      class="px-1 ma-1"
                    >
                      <span class="px-2 white--text">
                        {{ $t("to") }}
                        {{
                          item.payed_account ? $t(item.payed_account.name) : $t("haveNot")
                        }}
                        - {{ $t("date") }}:{{ item.payed_date }}
                      </span>
                    </v-chip>
                    <v-chip
                      v-if="type == 'payCheck' && item.type == 'customer'"
                      color="teal"
                      label
                      small
                      style="cursor: pointer"
                      outlined
                      class="px-1 ma-1"
                    >
                      <span class="px-2">
                        {{ $t("recieveCheck") }}
                      </span>
                    </v-chip>
                    <v-chip
                      v-if="item.initial_period"
                      color="primary"
                      label
                      small
                      style="cursor: pointer"
                      outlined
                      class="px-1 ma-1"
                    >
                      <span class="px-2">
                        {{ $t("initialPeriod") }}
                      </span>
                    </v-chip>
                    <v-chip
                      v-if="item.status && item.status.bank"
                      color="green"
                      label
                      small
                      style="cursor: pointer"
                      outlined
                      class="px-1 ma-1"
                    >
                      <span class="px-2">
                        {{ item.status.bank.name }}
                      </span>
                    </v-chip>
                    <v-chip
                      v-if="item.status && item.status.bank"
                      color="orange"
                      label
                      small
                      style="cursor: pointer"
                      outlined
                      class="px-1 ma-1"
                    >
                      <span class="px-2">
                        {{ $t("lastChangeStatus") }} : {{ item.status.time }}
                      </span>
                    </v-chip>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <v-chip
                      v-for="(relation, index) in item.relations"
                      :key="index"
                      :color="relation.color"
                      label
                      outlined
                      small
                      style="margin-left: 1px; margin-right: 1px"
                      class="px-1 mb-1"
                      @click="edit(item)"
                    >
                      {{ relation.name }}
                    </v-chip>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="item.tags" class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px; margin-right: 1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ms-1">
                  <v-btn dark text small color="primary" @click="edit(item)">
                    {{ $numberFormat(item.amount) }} {{ item.currency.name }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
            <v-menu offset-y>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  class="pl-action-cell__btn"
                  v-bind="attrs"
                  icon
                  x-small
                  v-on="on"
                >
                  <v-icon small> mdi-dots-vertical </v-icon>
                </v-btn>
              </template>

              <v-list dense>
              <v-list-item
                v-if="
                  (type !== 'removedChecks' &&
                    item.status &&
                    item.status.status == 'issued') ||
                  (item.status && item.status.status == 'fund')
                "
                link
                :disabled="item.lock ? true : false"
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-if="type !== 'removedChecks' && lockPermission"
                link
                @click="lock(item, item.lock ? 'unlock' : 'lock')"
              >
                <v-list-item-icon>
                  <v-icon :color="item.lock ? 'green' : 'pink'">
                    {{ item.lock ? "mdi-lock-open-outline" : "mdi-lock-outline" }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="item.lock ? $t('unlock') : $t('lock')" />
              </v-list-item>
              <v-list-item
                v-show="type !== 'removedChecks' && item.kind !== 'guarantee'"
                link
                @click="openCheckStatusDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-qrcode-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('change') + ' ' + $t('status')" />
              </v-list-item>
              <v-list-item
                v-if="type !== 'removedChecks'"
                v-clipboard:copy="editLink(item)"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <v-list-item v-if="item.doc_head_id" link @click="viewDocument(item)">
                <v-list-item-icon>
                  <v-icon>mdi-file-eye-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('viewAccountingDoc')" />
              </v-list-item>
              <v-list-item v-if="receiptKind" link @click="receiptPrint(item)">
                <v-list-item-icon>
                  <v-icon>mdi-receipt-text-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('treasuryReceiptPrint')" />
              </v-list-item>
              <v-list-item v-if="type === 'payCheck'" link @click="chequePrint(item)">
                <v-list-item-icon>
                  <v-icon>mdi-checkbook</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('chequeLeafPrint')" />
              </v-list-item>
              <v-list-item
                v-if="type !== 'removedChecks'"
                link
                @click="documentPrint(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print') + ' ' + $t('document')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                v-if="
                  ((item.status && item.status.status == 'issued') ||
                    (item.status && item.status.status == 'fund')) &&
                  removePermission(type)
                "
                link
                :disabled="item.lock ? true : false"
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
              </v-list>
            </v-menu>
            <span class="pl-action-cell__row">{{
              parseInt(items.indexOf(item)) + parseInt(from)
            }}</span>
          </div>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                {{ item.user.firstname }} {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.id="{ item }">
          <a
            @click="
              (item.status && item.status.status == 'issued') ||
              (item.status && item.status.status == 'fund')
                ? edit(item)
                : null
            "
          >
            {{ item.id }}
          </a>
          <v-icon v-if="item.lock" color="red" style="font-size: 22px">
            mdi-lock-outline
          </v-icon>
          <v-chip
            v-if="type === 'removedChecks'"
            :color="item.type === 'own' ? 'blue' : 'green'"
            label
            small
            style="margin-left: 1px; margin-right: 1px"
            class="px-1 mb-1"
          >
            <span class="px-1 white--text"> {{ $t("check") }} {{ $t(item.type) }} </span>
          </v-chip>
        </template>
        <template v-slot:item.doc_header.number="{ item }">
          <a v-if="item.doc_header" @click="documentPrint(item)">
            {{
              item.payedDocumentNumber ? item.payedDocumentNumber : item.doc_header.number
            }}
          </a>
        </template>
        <template v-slot:item.account.name="{ item }">
          <div class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-2"
              @click="openComponent('account', item.account.id)"
            >
              {{ item.account.name }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('accountingTurnover', item.account.fin_id)"
                >
                  <v-icon color="teal" style="font-size: 22px">
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("turnover") }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="item.tags || []" />
        </template>
        <template v-slot:item.amount="{ item }">
          {{ item.amount ? $numberFormat(item.amount, item.currency.decimal) : 0 }}
          {{
            item.amount && $store.state.currency.id !== item.currency.id
              ? "(" + item.currency.symbol + ")"
              : ""
          }}
        </template>
        <template v-slot:item.currency="{ item }">
          {{ item.currency.name }}
        </template>
        <template v-slot:item.bank="{ item }">
          {{
            item.type === "own"
              ? item.bank.number
                ? item.bank.name
                  ? item.bank.name
                  : $t("haveNot") + " - " + item.bank.number
                : item.bank.name
                ? item.bank.name
                : $t("haveNot") + " - " + $t("haveNot")
              : ""
          }}
          {{
            item.type === "customer"
              ? item.bank_account_number
                ? item.bank_name
                  ? item.bank_name
                  : $t("haveNot") + " - " + item.bank_account_number
                : item.bank_name
                ? item.bank_name
                : $t("haveNot") + " - " + $t("haveNot")
              : " "
          }}
        </template>
        <template v-slot:item.kind="{ item }">
          <!-- {{ item.type == "own" ? $t("normal") : $t(item.kind) }} -->
          {{ $t(item.kind) }}
        </template>
        <template v-slot:item.owner_name="{ item }">
          {{ item.owner_name || " - " }}
        </template>
        <template v-slot:item.relations="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(relation, index) in item.relations"
              :key="index"
              :color="relation.color"
              label
              outlined
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              {{ relation.name }}
            </v-chip>
          </div>
        </template>
        <template v-slot:item.status.status="{ item }">
          <v-chip
            v-if="item.status && item.status.status"
            :color="item.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1"
            @click="openCheckStatusDialog(item)"
          >
            <span class="px-2 white--text">
              {{ $t(item.status.status) }}
              {{
                item.status.status === "fund" && item.cashbox
                  ? "&nbsp;" + item.cashbox.name + ""
                  : ""
              }}
            </span>
          </v-chip>
          <v-chip
            v-if="item.payed_account_id && item.type == 'customer'"
            color="primary"
            label
            small
            style="cursor: pointer"
            class="px-1 ma-1"
          >
            <span class="px-2 white--text">
              {{ $t("to") }} {{ $t(item.payed_account.name) }} - {{ $t("date") }}:{{
                item.payed_date
              }}
            </span>
          </v-chip>
          <v-chip
            v-if="type == 'payCheck' && item.type == 'customer'"
            color="teal"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ $t("recieveCheck") }}
            </span>
          </v-chip>
          <v-chip
            v-if="item.initial_period"
            color="primary"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ $t("initialPeriod") }}
            </span>
          </v-chip>
          <v-chip
            v-if="item.status && item.status.bank"
            color="green"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ item.status.bank.name }}
            </span>
          </v-chip>
          <v-chip
            v-if="item.status && item.status.bank"
            color="orange"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ $t("lastChangeStatus") }} : {{ item.status.time }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:body.append>
          <tr v-if="isMobile || mobileShow">
            <td :colspan="`${isMobile ? 6 : Number(showHeaders.length)}`">
              <div style="width: 100%" class="pa-1">
                <strong>{{ $t("sumInPage") }}</strong
                >:
                <v-chip color="primary" class="px-1">
                  <span class="px-1 white--text">
                    {{ $numberFormat(totals.sum) }}
                  </span>
                </v-chip>
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <!-- Desktop fixed viewport: page totals sit above pagination, outside body scroll -->
          <div
            v-if="!isMobile && !mobileShow"
            class="app-list-page-totals"
          >
            <span class="app-list-page-totals__label">{{ $t("sumInPage") }}</span>
            <span
              class="app-list-page-totals__item app-list-page-totals__item--final"
            >
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.sum) }}
                {{ $store.state.currency.name }}
              </span>
            </span>
          </div>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="(titleProp ? $t(titleProp) : $t($route.name))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />
  </pro-list-frame>
</template>

<script>
/**
 * Desktop-only template for pay/receive/removed checks list.
 * Rendered via ChecksListDesktopBridge with checksList instance as `this`.
 */
export default {
  name: 'ChecksListDesktopView',
};
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
::v-deep .v-data-table.checkAverage .v-data-table-header {
  background-color: #d9d9d9;
}
::v-deep .v-data-table.checkAverage {
  border: 1px solid silver;
  /*  border-bottom: 0;
   border-bottom-right-radius: 0;
   border-bottom-left-radius: 0; */
  /* height: 300px;
  overflow-y: auto; */
}
::v-deep .v-data-table.checkAverage .v-data-table__wrapper::-webkit-scrollbar {
  width: 4px;
  height: 8px;
}
::v-deep .v-data-table.checkAverage .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}
::v-deep .v-data-table.checkAverage .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
/* ::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table {
  height: 100%;
} */
::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 8.3pt;
  border-left: 1px solid silver;
  padding: 0 9px;
  color: black;
  height: 40px !important;
  background-color: #eeeeee;
}
::v-deep
  .v-data-table.checkAverage
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child {
  border-top-right-radius: 4px;
}
::v-deep
  .v-data-table.checkAverage
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child {
  padding: 0 8px 0 4px;
  width: 30px;
  border-left: none;
  border-top-left-radius: 4px;
}
::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table > tbody {
  position: relative;
}
::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid silver;
  padding-right: 10px;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr:first-child:hover
  td:first-child {
  border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
  border-top-right-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:last-child {
  border-top: 1px solid silver;
  background-color: #f6f6f6;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
  background-color: #f6f6f6;
}
::v-deep
  .v-data-table.checkAverage
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  width: 0;
  border-left: none;
  padding: 0 8px 0 3.6pt;
}
</style>
